var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtificial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4088_168639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8961 14.3822L40.7426 18.9095L48.589 23.4402V32.5017V41.5597L40.7426 46.0905L32.8961 50.6212L25.0496 46.0905L17.2031 41.5597V32.5017V23.4402L25.0496 18.9095L32.8961 14.3822Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0469 26.6886V38.3113",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6797 35.4526H32.1411",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3203 38.2971L28.6739 26.8658C28.7624 26.6461 29.0707 26.6461 29.1628 26.8658L33.4774 38.2971",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6797 35.4526H32.1411",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44406 8.55505C8.15156 8.55505 9.53306 9.94018 9.53306 11.6476C9.53306 13.3551 8.15156 14.7366 6.44406 14.7366C4.73656 14.7366 3.35156 13.3551 3.35156 11.6476C3.35144 9.94018 4.73656 8.55505 6.44406 8.55505Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 11.6475H20.8564L25.047 18.9095",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1978 32.5017H8.96875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87806 29.4093C7.58556 29.4093 8.97056 30.7944 8.97056 32.5018C8.97056 34.2057 7.58544 35.5908 5.87806 35.5908C4.17419 35.5908 2.78906 34.2057 2.78906 32.5018C2.78906 30.7944 4.17406 29.4093 5.87806 29.4093Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1706 23.4402H10.6667L8.25781 19.2672",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2018 41.5597H10.6979L8.28906 45.7327",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5859 23.4402H55.0898L57.4987 19.2672",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5469 41.5597H55.0508L57.4631 45.7327",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5859 32.5017H56.8151",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.905 29.4093C58.1975 29.4093 56.8125 30.7944 56.8125 32.5018C56.8125 34.2057 58.1976 35.5908 59.905 35.5908C61.6124 35.5908 62.9975 34.2057 62.9975 32.5018C62.9975 30.7944 61.6125 29.4093 59.905 29.4093Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8906 14.3823V7.93152",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8047 4.839C29.8047 6.5465 31.1862 7.9315 32.8937 7.9315C34.6012 7.9315 35.9862 6.54638 35.9862 4.839C35.9862 3.13513 34.6011 1.75 32.8937 1.75C31.1862 1.75 29.8047 3.13513 29.8047 4.839Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8906 50.6212V57.0685",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8047 60.161C29.8047 58.4535 31.1862 57.0685 32.8937 57.0685C34.6012 57.0685 35.9862 58.4536 35.9862 60.161C35.9862 61.8684 34.6011 63.25 32.8937 63.25C31.1862 63.25 29.8047 61.8685 29.8047 60.161Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3468 8.55505C57.6429 8.55505 56.2578 9.94018 56.2578 11.6476C56.2578 13.3551 57.6429 14.7366 59.3468 14.7366C61.0543 14.7366 62.4393 13.3551 62.4393 11.6476C62.4393 9.94018 61.0543 8.55505 59.3468 8.55505Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2579 11.6475H44.9363L40.7422 18.9095",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44406 56.445C8.15156 56.445 9.53306 55.0599 9.53306 53.3526C9.53306 51.6452 8.15156 50.2635 6.44406 50.2635C4.73656 50.2635 3.35156 51.6451 3.35156 53.3526C3.35156 55.0601 4.73656 56.445 6.44406 56.445Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 53.3525H20.8564L25.047 46.0905",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3468 56.445C57.6429 56.445 56.2578 55.0599 56.2578 53.3526C56.2578 51.6452 57.6429 50.2635 59.3468 50.2635C61.0543 50.2635 62.4393 51.6451 62.4393 53.3526C62.4393 55.0601 61.0543 56.445 59.3468 56.445Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2579 53.3525H44.9363L40.7422 46.0905",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4088_168639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.890625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtificial);
export default __webpack_public_path__ + "static/media/artificial.1e724184b4fa5bd62ec0d1aaf6e65d39.svg";
export { ForwardRef as ReactComponent };